import "../../style.css";
import "../user-area.css";
import "./kalibracija.css";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../../api";
import Cookies from "universal-cookie";

const Kalibracija = ({ data }) => {
	const [parentBlacklist, setParentBlacklist] = useState(
		data["food_data"]["blacklist"]
	);
	const [parentWhitelist, setParentWhitelist] = useState(
		data["food_data"]["whitelist"]
	);
	const [active, setActive] = useState(false);

	const [meni, setMeni] = useState([]);
	const [current, setCurrent] = useState("...");

	const cookies = new Cookies();
	const sessionToken = cookies.get("sessionToken");
	const counterToken = () => {
		if (data["calibration_count"] === undefined) {
			return 0;
		} else {
			return data["calibration_count"];
		}
	};

	const [counter, setCounter] = useState(counterToken);

	const handleClick = async (option) => {
		if (!active) {
			setActive(true);
			let updatedCounter = counter + 1;

			if (option === "blacklist") {
				const isItemInWhitelist = parentWhitelist.includes(current);
				if (isItemInWhitelist) {
					setParentWhitelist((prevWhitelist) =>
						prevWhitelist.filter((item) => item !== current)
					);
				}

				setParentBlacklist((prevBlacklist) => [
					...prevBlacklist,
					current,
				]);
			} else if (option === "whitelist") {
				const isItemInBlacklist = parentBlacklist.includes(current);
				if (isItemInBlacklist) {
					setParentBlacklist((prevBlacklist) =>
						prevBlacklist.filter((item) => item !== current)
					);
				}
				setParentWhitelist((prevWhitelist) => [
					...prevWhitelist,
					current,
				]);
			}

			const data = {
				blacklist: parentBlacklist,
				whitelist: parentWhitelist,
			};

			try {
				const response = await fetch(
					`${API_URL}/api/menu_data_modification?token=${encodeURIComponent(
						sessionToken
					)}&menu_data=${JSON.stringify(data)}&type=jedi`
				);

				const responseData = await response.json();
				console.log(responseData);

				const calibrationResponse = await fetch(
					`${API_URL}/api/menu_data_modification?token=${encodeURIComponent(
						sessionToken
					)}&menu_data=${JSON.stringify(
						updatedCounter
					)}&type=calibration_count`
				);

				const calibrationData = await calibrationResponse.json();
				console.log(calibrationData);

				setCounter(updatedCounter);
			} catch (error) {
				console.log(error);
			} finally {
				setActive(false);
			}
		}
	};

	useEffect(() => {
		fetch(API_URL + "/api/full_menu")
			.then((response) => response.json())
			.then((data) => {
				const foodArray = Object.entries(data["data"]["data"]);
				foodArray.sort((a, b) => b[1] - a[1]);
				const uniqueKeysMap = new Map();
				const resultArray = [];

				for (const [food] of foodArray) {
					if (!uniqueKeysMap.has(food)) {
						uniqueKeysMap.set(food, true);
						resultArray.push(food);
					}
				}
				resultArray.shift();
				resultArray.shift();
				setMeni(resultArray);
				setCounter(counterToken);
				setCurrent(resultArray[counter]);
			})
			.catch((error) => {
				console.log(error);
			});
	}, []);

	useEffect(() => {
		setCurrent(meni[counter]);
	}, [counter]);

	const handleNeutralClick = () => {
		setCounter(counter + 1);
	};

	const handleBackClick = () => {
		setCounter(counter - 1);
	};

	return (
		<div>
			<div className="kalibracija" id="meniblk">
				<h2>{current}</h2>
				<div className="choose-btns">
					<button
						className="btn red-shadow choose-btn"
						style={{ color: "red", borderColor: "red" }}
						onClick={() => handleClick("blacklist")}>
						Nezaželjeno
					</button>
					<button
						className="btn green-shadow choose-btn"
						style={{ color: "#03f43b", borderColor: "#03f43b" }}
						onClick={() => handleClick("whitelist")}>
						Zaželjeno
					</button>
				</div>
				<div className="other-btn">
					<button
						className="btn choose-btn"
						onClick={handleBackClick}>
						Nazaj
					</button>
					<button
						className="btn choose-btn"
						onClick={handleNeutralClick}>
						Preskoči
					</button>
				</div>
				<h3>
					{counter} / {meni.length} (če prideš do 100 bi moglo biti
					kar OK kalibrirano.)
				</h3>
			</div>
		</div>
	);
};

export default Kalibracija;
